import { useIntl } from 'react-intl'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import LoyaltyBurnPriceDisplay from 'loyalty/components/LoyaltyBurnPriceDisplay'
import { getExperienceTileSaleUnit } from 'lib/experiences/getExperienceTileSaleUnit'
import type { ExperienceSearchTileBurn } from 'components/Experiences/hooks/useExperienceSearchTileBurn'
import ExperienceTilePrices from './ExperienceTilePrices'

interface Props {
  tileBurn: ExperienceSearchTileBurn
  totalPrice?: number
  totalMemberPrice?: number
  totalGrossPrice?: number
  discountPercentage?: number
  isFromPrice: boolean
  ticketUnitLabel: string
  size?: 'S' | 'L' | 'M'
  nonMemberPriceSize?: 'L' | 'M'
  discountMemberPercentage?: number
}

function ExperienceTilePricesWithBurn(props: Props) {
  const {
    tileBurn,
    totalPrice,
    totalMemberPrice,
    totalGrossPrice,
    discountPercentage,
    isFromPrice,
    ticketUnitLabel,
    size = 'S',
    nonMemberPriceSize = 'M',
    discountMemberPercentage,
  } = props

  const intl = useIntl()
  const {
    viewPriceInPoints,
    isSocietePricingActive,
    showLuxPlusPricing,
    nonMemberBurn,
    memberBurn,
  } = tileBurn

  const fromCaption = intl.formatMessage({
    id: 'EAQ_GV7KRwveLWB08EmL',
    defaultMessage: 'From',
    description: 'Price caption prefix on the experience tile prices',
  })
  const totalLabel = intl.formatMessage({
    id: 'whMf0sOzbI-AWwhc2zR7',
    defaultMessage: 'total',
    description: 'Sale unit label for total price on experience tile prices',
  })
  const saleUnit = getExperienceTileSaleUnit({ isFromPrice, ticketUnitLabel, totalLabel })

  const cashPrices = (
    <ExperienceTilePrices
      totalPrice={totalPrice}
      totalMemberPrice={totalMemberPrice}
      totalGrossPrice={totalGrossPrice}
      discountPercentage={discountPercentage}
      isFromPrice={isFromPrice}
      ticketUnitLabel={ticketUnitLabel}
      size={size}
      nonMemberPriceSize={nonMemberPriceSize}
      discountMemberPercentage={discountMemberPercentage}
    />
  )

  const isBurnPricingLoading = isSocietePricingActive && (
    !nonMemberBurn.enabled
    || (showLuxPlusPricing && memberBurn.priceInPoints === undefined)
  )

  if (isBurnPricingLoading) {
    if (viewPriceInPoints) return cashPrices
    return isFromPrice ? <PriceRowPriceCaption>{fromCaption}</PriceRowPriceCaption> : null
  }

  const shouldShowBurn = nonMemberBurn.enabled
    && nonMemberBurn.priceInPoints
    && (nonMemberBurn.pointsOnly || nonMemberBurn.pointsToBurn !== undefined)

  if (shouldShowBurn) {
    return (
      <>
        {isFromPrice && <PriceRowPriceCaption>{fromCaption}</PriceRowPriceCaption>}
        <LoyaltyBurnPriceDisplay
          totalPrice={totalPrice ?? 0}
          pointsToBurn={nonMemberBurn.pointsToBurn}
          priceInPoints={nonMemberBurn.priceInPoints}
          memberPrice={totalMemberPrice}
          memberPriceInPoints={memberBurn.priceInPoints}
          size={size}
          saleUnit={saleUnit}
          pointsOnly={nonMemberBurn.pointsOnly}
          hideZeroCash={nonMemberBurn.hideZeroCash}
        />
      </>
    )
  }

  return cashPrices
}

export default ExperienceTilePricesWithBurn
